import React from 'react'
import './Pacientes.css'
import Header from '../Header/Header'
import PacientesData from '../../Components/Admin/PacientesData/PacientesData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
export default function Pacientes() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <PacientesData />
                </div>
            </section>
        </div>
    )
}
